var React = require('react');

function Bag (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rectangle_37725","data-name":"Rectangle 37725","width":"22","height":"22","fill":"none","key":0}),React.createElement("g",{"id":"bag-alt-r","transform":"translate(-1 -1.344)","key":1},React.createElement("path",{"id":"Path_104311","data-name":"Path 104311","d":"M8.061,4,4.811,7.25H19.189L15.939,4,17,2.939,21.311,7.25h.439v5.5h-2v9H4.25v-9h-2V7.25h.439L7,2.939ZM18.25,12.75H5.75v7.5h12.5Zm2-1.5V8.75H3.75v2.5Z","fill":"currentColor","fillRule":"evenodd"}))]);
}

Bag.defaultProps = {"id":"bag2","width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Bag;

Bag.default = Bag;
